import { FC, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaOptionsType } from 'embla-carousel'
import './hotelEmblaCarosel.css'
import { ColoursObj, Typography } from '@eventr/common-storybook'

type THotelImageCarouselProps = {
    images: string[]
}

export const HotelImageCarousel: FC<THotelImageCarouselProps> = ({
    images,
}) => {
    const options: EmblaOptionsType = { loop: true }

    const [emblaRef, emblaApi] = useEmblaCarousel(options)
    const [selectedIndex, setSelectedIndex] = useState<number>(0)

    useEffect(() => {
        if (emblaApi) {
            emblaApi.on('scroll', () => {
                setSelectedIndex(emblaApi.selectedScrollSnap())
            })
        }
    }, [emblaApi])

    /// To scroll to top of page...
    useEffect(() => {
        setTimeout(() => {
            window.document
                .getElementById('carouselImageHotels')
                .scrollIntoView()
        }, 100)
    }, [])

    if (!images || images.length < 1) {
        return null
    }

    return (
        <Box id="carouselImageHotels">
            <section className="embla">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">
                        {images.map((imageUrl, index) => {
                            const imageSrc =
                                selectedIndex === index || /// Current
                                selectedIndex + 1 === index || /// Next
                                selectedIndex - 1 === index || /// Previous
                                index === 0 || /// First
                                index === images.length - 1 /// Last
                                    ? imageUrl
                                    : '' /// Otherwise dont load.
                            return (
                                <div className="embla__slide" key={index}>
                                    <div
                                        style={{
                                            width: '100dvw',
                                            height: '250px',
                                            backgroundImage: `url(https:${imageSrc})`,
                                            backgroundPosition: 'bottom',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                        }}
                                    ></div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
            <Box
                position={'absolute'}
                right={'0'}
                top={'206px'}
                display={'grid'}
            >
                <Box
                    boxShadow={1}
                    sx={{
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        borderRadius: '8px',
                        padding: '2px 6px',
                        margin: '8px',
                    }}
                >
                    <Typography color={ColoursObj.shades.shade5}>
                        {selectedIndex + 1} / {images.length}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}
